import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as getInstitutional } from '../../../../../domain/useCases/getInstitutionalInformation';
import InstitutionalInformationModuleView from './InstitutionalInformationModuleView';

import useProfile from '@/presentation/hooks/useProfile';

const InstitutionalInformationModuleController: FC = () => {
  const { academic } = useProfile();
  const dispatch = useDispatch();

  const history = useHistory();

  const { isLoading, data, error } = useSelector(
    (state: any) => state.getInstitutionalInformation
  );

  const handlerBack = () => history.push('/inicio');

  React.useEffect(() => {
    dispatch(
      getInstitutional.getInstitutionalInformation(
        academic.campus,
        academic.career,
        academic?.zone === null ? '' : academic?.zone
      )
    );
  }, []);

  return (
    <InstitutionalInformationModuleView
      isLoading={isLoading}
      handlerBack={handlerBack}
      titles={data ? data?.institutionalInformationStudent : []}
      hasError={error}
    />
  );
};

export default InstitutionalInformationModuleController;
